import React, { useState } from "react";
import { Swiper, SwiperSlide, useSwiperSlide } from "swiper/react";
import { Navigation, Mousewheel, Keyboard } from "swiper";
import { useSwiper } from "swiper/react";
import { Box, Typography } from "@mui/material";
import tick from "assets/icons/tick.png";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./swiperSteps.scss";

const SwiperSteps = (props) => {
  const { tab, list = [], maxWidthSwiper = "" } = props;
  const ListItemsLength = list.length;

  const renderMark = (item) => {
    const { isError, isCompleted } = item;
    if (isCompleted) {
      return (
        <Box
          component="img"
          src={tick}
          width="15px"
          sx={{
            cursor: "pointer",
            zIndex: 2,
          }}
          onClick={() => {}}
        />
      );
    }

    if (isError) {
      return (
        <Box
          component="div"
          sx={{
            cursor: "pointer",
            zIndex: 1,
          }}
          onClick={() => {
            props.nextCard();
          }}
        >
          <Typography fontWeight="bold" fontSize="19px">
            !
          </Typography>
        </Box>
      );
    }
  };

  let maxWidthFirstELStyle = {
    left: "30%",
  };
  let maxWidthLaststELStyle = {
    left: "70%",
  };

  return (
    <>
      <Box className="custom-swiper-container">
        <Swiper
          cssMode={true}
          breakpoints={{
            280: {
              slidesPerView: 1,
            },
            480: {
              slidesPerView: 2,
            },

            640: {
              slidesPerView: 3,
            },
            900: {
              slidesPerView: Math.ceil(ListItemsLength),
            },
            1200: {
              slidesPerView: Math.ceil(ListItemsLength),
            },
          }}
          navigation={true}
          mousewheel={true}
          keyboard={true}
          modules={[Navigation, Mousewheel, Keyboard]}
          className="custom-doc-swiper"
        >
          {list?.map((item, index, arr) => (
            <SwiperSlide className="swiper-slide" key={item.name}>
              <Box
                component="div"
                display="flex"
                alignItems="flex-end"
                height="60px"
                className="bars"
              >
                <Box
                  className="text-container"
                  component="div"
                  sx={{
                    position: "absolute",
                    left: "50%",
                    top: "0%",
                    transform: "translate(-50%,0%)",
                    ...(!maxWidthSwiper && {
                      width: "100% ",
                      textAlign: "center",
                    }),
                    ...(maxWidthSwiper && index === 0 && maxWidthFirstELStyle),
                    ...(maxWidthSwiper &&
                      index === ListItemsLength - 1 &&
                      maxWidthLaststELStyle),
                  }}
                >
                  <Typography
                    variant="inherit"
                    fontSize="11.5px"
                    lineHeight="16px"
                    fontWeight="400"
                    textAlign={"center"}
                    width={"max-content"}
                  >
                    {item.name}
                  </Typography>
                </Box>
                <Box
                  className={`horizontal-bar-first ${
                    index !== 0 ? "" : "hide"
                  }`}
                  sx={{
                    backgroundColor: "#6f42c1",
                    ...(maxWidthSwiper &&
                      index === 0 && { width: "30% !important" }),
                    ...(maxWidthSwiper &&
                      index === ListItemsLength - 1 && {
                        width: "70% !important",
                      }),
                  }}
                />
                <Box
                  className="circle-container"
                  sx={{
                    borderRadius: "50%",
                    position: "absolute",
                    left: "50%",
                    top: "calc(100% - 3px)",
                    cursor: "pointer",
                    boxShadow: "0px 0px 3px 3px rgba(0,0,0,0.15)",
                    transform: "translate(-50%,-100%)",
                    ...(maxWidthSwiper && index === 0 && maxWidthFirstELStyle),
                    ...(maxWidthSwiper &&
                      index === ListItemsLength - 1 &&
                      maxWidthLaststELStyle),
                  }}
                >
                  <Box
                    className="circle"
                    sx={{
                      position: "relative",
                      color: tab === item.id ? "#444561" : "#957ba0",
                      backgroundColor: tab == item.id ? "#ffffff" : "#d0c8db",
                      ...(tab == item.id && { filter: "contrast (900%)" }),
                    }}
                    onClick={() => {}}
                  >
                    {renderMark(item)}
                  </Box>
                </Box>
                <Box
                  className={`horizontal-bar-second ${
                    index !== arr.length - 1 ? "" : "hide"
                  }`}
                  sx={{
                    backgroundColor: "#6f42c1",
                    ...(maxWidthSwiper &&
                      index === 0 && { width: "70% !important" }),
                    ...(maxWidthSwiper &&
                      index === ListItemsLength - 1 && {
                        width: "30% !important",
                      }),
                  }}
                />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </>
  );
};
export default SwiperSteps;
